
<template lang="pug">
.layout-split.bg-ledap
	.content.justify-content-center.safe-area-inset-top
		b-row
			b-col.mr-2(align="end")
				LangSwitcher(style="max-width: 150px").float-right

		img.company-logo.mt-4.pb-5(src="/img/bookli-logo.svg")

		b-card.bg-white.m-0.p-0
			b-overlay.m-0(
				:show="signInLoading"
				spinner-variant="primary"
				variant="transparent")

				b-row
					b-col(v-if="showAppleSingInOption")
						b-button.mb-3(
							block
							size="lg"
							@click="singInWithApple()"
							variant="dark")
							.d-flex.align-items-center.justify-content-center
								img.mr-3(
									class="inline"
									width="18px"
									src="/img/apple-logo-white.png")
								span(style="madiv(v-rgin-top: 2px;") {{ $t('pages.auth.signIn.appleSignInButton') }}
					b-col(v-if="showFacebookSingInOption")
						b-button(
							block
							size="lg"
							@click="singInWithFacebook()"
							variant="dark")
							.d-flex.align-items-center.justify-content-center
								img.mr-3(
									class="inline"
									width="23px"
									src="/img/facebook-white.svg")
								span {{ $t('pages.auth.signIn.facebookSignInButton') }}

				.text-center.py-3
					small.text-muted {{ $t('common.staticTemp.signIn.credentials') }}

				validation-observer(ref='observer' v-slot='{ invalid, validate }')
					b-form(@submit.prevent="validate().then(signInUser())")

						b-form-group(:label="$t('input.email.label')")
							validation-provider(name='email' rules='required|email' v-slot='{ errors, untouched }')

								b-form-input(
									:state='untouched === true ? null : errors.length == 0 ? true : false'
									v-model='signInData.email'
									type='email'
									:placeholder="$t('input.email.placeholder')"
									name='email')
								b-form-invalid-feedback(:state='errors.length == 0') {{errors[0]}}

						b-form-group(:label="$t('input.password.label')")
							validation-provider(name='password' rules='required' v-slot='{ errors, untouched }')
								b-form-input(
									:state='untouched === true ? null : errors.length == 0 ? true : false'
									v-model='signInData.password'
									type='password'
									:placeholder="$t('input.password.placeholder')"
									name='password')
								b-form-invalid-feedback(:state='errors.length == 0') {{errors[0]}}
							small.text-muted.mt-1.d-block {{ $t('pages.auth.signIn.newPassword') }}&nbsp;
								router-link(:to="{ name: 'PasswordReset' }") {{ $t('pages.auth.signIn.newPasswordGet') }}

						b-button.mb-3.mt-4(
							variant="outline-primary"
							block
							type="submit"
							size="lg"
							:disabled="invalid || signInLoading")
							span(v-if="signInLoading")
								b-spinner.button-loading(small type="grow")
								span {{ $t('pages.auth.signIn.signInLoadingButton') }}
							span(v-else) {{ $t('pages.auth.signIn.signInButton') }}


				.text-center.mt-3
					small.text-muted.text-center {{ $t('pages.auth.signIn.dontHaveAAccount') }}&nbsp;
						router-link(:to="{ name: 'SignUpUser' }") {{ $t('pages.auth.signIn.dontHaveAAccountButton') }}

	.image(style='background-image: url(/img/covers/auth-side-cover.jpg);')


	ChangeUserDefaultLocation(
		:returnToHome="true"
		:showChangeLink="false"
		:title="$t('pages.auth.signIn.changeUserDefaultLocation.title')"
		:description="$t('pages.auth.signIn.changeUserDefaultLocation.description')"
		ref="changeUserDefaultLocation"
	)

	b-modal(
		id="signin-method-modal"
		ref="signInMethodModal"
		:title="$t('pages.auth.signIn.wrongSignInMethod.label')"
		title-tag="h4"
		:hide-header-close="false"
		size="md"
		centered
		hide-footer)

		div(v-if="userSignInMethod === 'Facebook'") 
			p.text-muted {{ $t('pages.auth.signIn.wrongSignInMethod.facebook') }}

			b-button(v-if="showFacebookSingInOption"
				block
				size="lg"
				@click="singInWithFacebook()"
				variant="dark")
				.d-flex.align-items-center.justify-content-center
					img.mr-3(
						class="inline"
						width="23px"
						src="/img/facebook-white.svg")
					span {{ $t('pages.auth.signIn.facebookSignInButton') }}

		div(v-else-if="userSignInMethod === 'Apple'") 
			p.text-muted {{ $t('pages.auth.signIn.wrongSignInMethod.apple') }}

			b-button.mb-3(
				v-if="showAppleSingInOption"
					block
					size="lg"
					@click="singInWithApple()"
					variant="dark")
					.d-flex.align-items-center.justify-content-center
						img.mr-3(
							class="inline"
							width="18px"
							src="/img/apple-logo-white.png")
						span(style="madiv(v-rgin-top: 2px;") {{ $t('pages.auth.signIn.appleSignInButton') }}
	b-modal(
		id="select-company-modal"
		ref="selectCompanyModal"
		:title="$t('pages.auth.signIn.selectCompany.title')"
		title-tag="h4"
		:hide-header-close="true"
		size="md"
		centered
		hide-footer
		:no-close-on-backdrop="true")

		userPlatformConnections

		b-button.mt-4(
			variant="outline-primary"
			@click="signUserOut()"
			block) {{ $t('pages.auth.signIn.selectCompany.signOut') }}

	b-modal(
		:title="$t('common.staticTemp.signIn.facebookLogin')"
		ref="android-facebook-modal"
		title-tag="h4"
		centered
		hide-footer
		size="sm")
		p.text-muted {{ $t('pages.auth.signIn.facebookAndroidError.description') }}

		b-button(
			@click="openUrl('https://bookli.app')"
			variant="primary"
			block) {{ $t('pages.auth.signIn.facebookAndroidError.openBookliApp') }}

		b-button.mt-3(
			@click="$refs['android-facebook-modal'].hide()"
			variant="secondary"
			block) {{ $t('pages.auth.signIn.facebookAndroidError.closeWindow') }}


</template>
<script lang="ts">
import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { GetLocationUserDefault, GetLocationUserDefaultQuery, AppleSignInInput, GetUserSignInMethod, GetUserSignInMethodQueryVariables, GetUserSignInMethodQuery, GetUserBasics, GetUserBasicsQueryVariables  } from '@/graphql'
import UserPlatformConnections from '@/components/auth/userPlatformConnections.vue'
import { Capacitor } from '@capacitor/core'
import { FacebookLogin } from '@capacitor-community/facebook-login'
import { Preferences } from '@capacitor/preferences'
import ChangeUserDefaultLocation from '@/components/app/changeUserDefaultLocation.vue'
import { SignInWithApple } from '@capacitor-community/apple-sign-in'

import LangSwitcher from '@/components/shared/langSwitcher.vue'
import { useAuthStore } from '@/store/modules/auth'
import { sendSegmentData, SegmentTypeOfEvent } from '@/segment/segmentData'
import { useUserStore } from '@/store/modules/user'



@Component({
	components: {
		UserPlatformConnections,
		ChangeUserDefaultLocation,
		LangSwitcher
	},
	apollo: {

	}
})
export default class CompanyUsersUserView extends Vue {
	Auth = useAuthStore()
	User = useUserStore()
	userSignInMethod = ''
	signInLoading = false
	signInData = {
		email: '',
		password: ''
	}

	created() {
		if (Capacitor.getPlatform() === 'ios') {
			this.showAppleSingInOption = true
		}

		if (import.meta.env.DEV) {
			this.signInData = {
				email: 'company@bookli.dk',
				password: '1Hehekom'
			}
		}
	}

	async mounted() {
		const { value: userAuthToken } = await Preferences.get({ key: 'USER_TOKEN' })

		if (userAuthToken) {
			// console.log('USER_TOKEN remove')
			// await Preferences.remove({ key: 'USER_TOKEN' })
		}

		// await this.checkLoginStateFacebook()

		if (this.$route.params.autoSignInFacebook) {
			this.singInWithFacebook()
		}

		if (this.$route.params.autoSignInApple) {
			this.singInWithApple()
		}
	}

	async singInWithApple() {
		try {
			const signIn = await SignInWithApple.authorize({
				clientId: 'dk.bookli.app',
				redirectURI: 'https://bookli.app',
				scopes: 'email name',
			})
			const data = signIn.response

			if (data.user) {
				await this.signInUser({
					appleSignIn: {
						userId: data.user,
						firstName: data.givenName || undefined,
						lastName: data.familyName || undefined,
						email: data.email || undefined
					}
				})
			}
		} catch (error) {
			console.log('Sign error', error)
		}
	}

	async singInWithFacebook() {
		try {
			const result = await FacebookLogin.login({
				permissions: ['email']
			})
			if (result.accessToken) {
				await this.signInUser({
					facebookAuthToken: result.accessToken.token
				})
			}
		} catch (error) {
			console.log('fb error', error)
		}
	}

	showAppleSingInOption = false

	openUrl(url: string) {
		const win = window.open(url, '_blank')
		win!.focus()
	}

	showFacebookSingInOption = true
	async checkLoginStateFacebook() {
		const result = await FacebookLogin.getCurrentAccessToken().catch(() => undefined)
		const hasFBAccessToken = !(result === undefined || !result.hasOwnProperty('accessToken'))

		if (hasFBAccessToken) {
			// Vi skal ikke auto logge ind for det skaber bare et loop / man kan aldrig logge ud
			/*
			await this.signInUser({
				facebookAuthToken: result.accessToken.token
			})
			*/
		}
	}

	async signInMethod(email: string) {
		const { data } = await this.$apollo.query<GetUserSignInMethodQuery, GetUserSignInMethodQueryVariables>({
			query: GetUserSignInMethod,
			variables: {
				emailAddress: email
			},
		})
		const { signInMethod } = data
		const { userSignInMethod } = signInMethod

		if (userSignInMethod === "Facebook" || userSignInMethod === "Apple") {
			this.userSignInMethod = userSignInMethod
			this.$refs['signInMethodModal']?.show()
		}
	}

	async signInUser(data?: { facebookAuthToken?: string, appleSignIn?: AppleSignInInput }) {
		this.signInLoading = true

		try {
			if (data && data.facebookAuthToken) {
				await this.Auth.signInUser({
					facebookAuthToken: data.facebookAuthToken
				})
			}
			else if (data && data.appleSignIn) {
				await this.Auth.signInUser({
					appleSignIn: data.appleSignIn
				})
			}
			else {
				await this.Auth.signInUser({
					emailAndPassword: {
						email: this.signInData.email,
						password: this.signInData.password
					}
				})
			}
			this.signInLoading = false
			this.selectPlatform()
		} catch (error) {
			if (this.signInData.email) {
				this.signInMethod(this.signInData.email)
			}
			this.signInLoading = false
		}
	}

	async signUserOut() {
		// @ts-ignore
		this.$refs['selectCompanyModal'].hide()
		await this.Auth.signUserOut()
	}
	

	async selectPlatform() {
		this.signInLoading = true

		if (!this.Auth.userPlatformConnections.length) {
			//@ts-ignore
			this.$refs['changeUserDefaultLocation'].show()
			this.signInLoading = false
			return
		}

		const getUserDefaultLocation = await this.$apollo.query({
			query: GetLocationUserDefault,
		})
		
		const userDefaultLocation = getUserDefaultLocation.data as GetLocationUserDefaultQuery

		const userOnlyHaveUserRoles = this.Auth.userPlatformConnections.find(x => x.role !== 'User') ? false : true

		if (userOnlyHaveUserRoles) {
			if (!userDefaultLocation.locationUserDefault) {
				//@ts-ignore
				this.$refs['changeUserDefaultLocation'].show()
			} else {
				await this.Auth.signInPlatform({ userPlatformConnectionId: userDefaultLocation.locationUserDefault.company.userPlatformConnection!.id })
			}
			this.signInLoading = false
				
			const variables: GetUserBasicsQueryVariables = {
				id: this.User.currentUser?.id
			}
			
			const user = await this.$apollo.query({
				query: GetUserBasics,
				variables
			});

			const dataForSegment = {
				first_name: user.data.user.firstName,
				last_name: user.data.user.lastName,
				email: user.data.user.email,
				city: user.data.user.city,
				zip_code: user.data.user.zipCode,
				country: user.data.user.country,
				phone_number: user.data.user.phoneNumber,
				booking_system: 'Bookli',
			}

			sendSegmentData(SegmentTypeOfEvent.IdentifyUser, dataForSegment)
		
			if (this.Auth.preAuthRoute) {
				this.$router.push({path: this.Auth.preAuthRoute})
			}

			return
		}
		else {
			//@ts-ignore
			this.$refs['selectCompanyModal'].show()
		}
		this.signInLoading = false
	}
}
</script>

<style scoped lang="sass">

.company-logo
	width: 250px
	display: block
	margin: 0 auto 30px


</style>
